import React from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

export type CaptchaProps = {
    lang: string;
    children: React.ReactNode;
}

const ReCaptchaV3 = ({lang, children}: {
        lang: string;
        children: React.ReactNode;
}) => {
  const siteKey = process.env.RECAPTCHA_SITE_KEY ?? '';
  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={siteKey}
      language={lang}
      scriptProps={{
        async: false, // optional, default to false,
        defer: false, // optional, default to false
        appendTo: 'head', // optional, default to "head", can be "head" or "body",
      }}
      container={{
        // optional to render inside custom element
        parameters: {
          badge: 'inline', // optional, default undefined
          theme: 'dark', // optional, default undefined
        },
      }}
    >
      {children}
    </GoogleReCaptchaProvider>
  );
};

export default ReCaptchaV3;